import { render, staticRenderFns } from "./CadastrarConvenio.vue?vue&type=template&id=6937201a"
import script from "./CadastrarConvenio.vue?vue&type=script&lang=js"
export * from "./CadastrarConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports